<template>
  <div class="advertisement-content">
    <div class="advertisement-content-list">
      <div
        class="advertisement-content-list-item"
        v-for="(item, index) in dataList"
        :key="index"
      >
        <div class="item-left">
          <img src="../assets/default.png" alt="" class="user-avatar" />
          <span class="user-name">{{ item.userName }}</span>
          <img
            src="../assets/company.png"
            alt=""
            class="user-type"
            v-if="item.userType == 2"
          />
          <img src="../assets/person.png" alt="" class="user-type" v-else />
        </div>

        <div class="item-middle">
          <h3 class="project-name">
            {{ item.companyName == null ? "个人用户" : item.companyName }}
          </h3>
          <p class="project-desc">账号：{{ item.mobilePhone }}</p>
          <p class="project-meta">创建时间：{{ formatTime(item.createTime) }}</p>
        </div>

        <div class="item-right">
          <div class="info-item">
            <span class="info-label">类型</span>
            <span class="info-value">{{
              item.userType == 2 ? "企业" : "个人"
            }}</span>
          </div>
          <div class="detail-btn" @click="handleDetail(item)">
            查看详情
          </div>
        </div>
      </div>
    </div>
    <el-pagination
      style="text-align: right"
      @current-change="handleCurrentChange"
      layout="prev, pager, next"
      class="pagination"
      :page-size="pageSize"
      :total="total"
      v-if="total > 0"
    >
    </el-pagination>
  </div>
</template>

<script>
import { sysGetAuditeUserList } from "../utils/records";
export default {
  data() {
    return {
      dataList: [],
      total: 0,
      pageNo: 1,
      pageSize: 6,
    };
  },
  props: {
    type: {
      type: String,
    },
  },
  methods: {
     formatTime(timeStr) {
      if (!timeStr) return "";
      const date = new Date(timeStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    // 分页
    handleCurrentChange(page) {
      this.pageNo = page;
      this.getList();
    },
    handleDetail(item) {
      this.$router.push({ path: "/userDetail", query: { item: encodeURIComponent(JSON.stringify(item)) } });
    },
    getList() {
      let data = {
        status: 0,
      };
      sysGetAuditeUserList(data).then((res) => {
        console.log('@',res);
        if (res.data.code == 200) {
          this.$nextTick(() => {
            this.dataList = res.data.data;
            this.total = res.data.total;
          });
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
  },
  activated() {
    this.getList();
  },
};
</script>

<style scoped lang="less">
.fontdemo(@size,@family,@weight,@color) {
  font-size: @size;
  font-family: @family;
  font-weight: @weight;
  color: @color;
}

.advertisement-content{
  width: 100%;
  min-height: calc(100vh - 320px);
  box-sizing: border-box;
  padding: 52px 120px 80px;
  background: #232732;
  font-family: PingFangSC, PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif;

  &-list{
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 24px;

    &-item{
      width: 100%;
      box-sizing: border-box;
      padding: 24px 32px;
      background: #121212;
      border: 1px solid #F9C92E;
      border-radius: 8px;
      display: flex;
      align-items: center;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover{
        transform: translateY(-2px);
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4);
        border-color: #ffd700;
      }

      .item-left{
        display: flex;
        align-items: center;
        gap: 12px;
        flex-shrink: 0;

        .user-avatar{
          width: 48px;
          height: 48px;
          border-radius: 50%;
          border: 2px solid #F9C92E;
          object-fit: cover;
        }

        .user-name{
          .fontdemo(16px, 'PingFangSC,PingFang SC', 500, #ffffff);
        }

        .user-type{
          width: 20px;
          height: auto;
        }
      }

      .item-middle{
        flex: 1;
        margin: 0 40px;

        .project-name{
          .fontdemo(18px, 'PingFangSC,PingFang SC', 600, #ffffff);
          margin: 0 0 8px 0;
          line-height: 1.3;
          text-align: left;
        }

        .project-desc{
          .fontdemo(14px, 'PingFangSC,PingFang SC', 400, rgba(255,255,255,0.6));
          line-height: 1.5;
          margin: 0 0 6px;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          display: -webkit-box;
          text-align: left;
        }

        .project-meta{
          .fontdemo(13px, 'PingFangSC,PingFang SC', 400, rgba(255,255,255,0.45));
          line-height: 1.5;
          margin: 0;
          text-align: left;
        }
      }

      .item-right{
        display: flex;
        align-items: center;
        gap: 32px;
        flex-shrink: 0;

        .info-item{
          text-align: right;
          min-width: 72px;

          .info-label{
            display: block;
            .fontdemo(12px, 'PingFangSC,PingFang SC', 400, rgba(255,255,255,0.5));
            margin-bottom: 4px;
          }

          .info-value{
            display: block;
            .fontdemo(18px, 'PingFangSC,PingFang SC', 600, #F9C92E);
            line-height: 1.2;
          }
        }

        .detail-btn{
          min-width: 108px;
          height: 40px;
          padding: 0 20px;
          border-radius: 999px;
          border: 1px solid rgba(249, 201, 46, 0.7);
          background: linear-gradient(135deg, rgba(249, 201, 46, 0.12) 0%, rgba(249, 201, 46, 0.02) 100%);
          .fontdemo(14px, 'PingFangSC,PingFang SC', 500, #F9C92E);
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;

          &:hover{
            background: linear-gradient(135deg, #f9c92e 0%, #d8a516 100%);
            color: #141414;
            box-shadow: 0 8px 16px rgba(249, 201, 46, 0.25);
          }
        }
      }
    }
  }
}

.pagination{
  max-width: 1400px;
  margin: 32px auto 0;
  text-align: right;
}

/deep/ .el-pagination {
  color: rgba(255, 255, 255, 0.78);
}

/deep/ .btn-prev,
/deep/ .btn-next,
/deep/ .el-pager li {
  min-width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.8);
  margin: 0 8px;
}

/deep/ .el-pager .active {
  background: linear-gradient(135deg, #f9c92e 0%, #d8a516 100%);
  color: #141414;
}
</style>
